import { useCallback } from 'react'
import moviesApi from '../client/movies-api'
import { MovieDetailDTO } from '../types/Movie'
import { useApiData } from './useApiData'

export function useMovieDetails(movieId?: string) {
  const parsedMovieId = movieId ? parseInt(movieId, 10) : undefined
  const isValidMovieId = parsedMovieId !== undefined && !isNaN(parsedMovieId)

  const fetchMovieDetails = useCallback(
    () => moviesApi.getById(parsedMovieId!),
    [parsedMovieId]
  )

  const { data, isLoading, error, status, refetch } = useApiData<MovieDetailDTO>(
    fetchMovieDetails,
    [parsedMovieId],
    {
      errorMessage: 'Failed to load movie details',
      enabled: isValidMovieId,
    }
  )

  return {
    data,
    loading: isLoading,
    error,
    status,
    refetch,
  }
}
